import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useAppServices } from 'hook/services'
import { useUserInfo } from 'context/user'
import MDInput from 'components/MDInput'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import Multiselect from './MultiSelect'

const EditModal = ({ editData, handleRefresh }) => {
  const AppService = useAppServices()
  const [openEditModal, setOpenEditModal] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [user] = useUserInfo()
  const [tags, setTags] = useState([])
  const [categories, setCategory] = useState([])
  const [team, setTeam] = useState([])
  const [staffData, setStaffData] = useState([])

  useEffect(() => {
    getTags()
    getCategory()
    getTeam()
    getStaff()
  }, [])

  const getTags = async () => {
    const { response } = await AppService.team_tags.get({ toaster: false })
    setTags(response ? response.data : [])
  }

  const getCategory = async () => {
    const { response } = await AppService.servicecategory.get({ toaster: false })
    setCategory(response ? response.data : [])
  }

  const getTeam = async () => {
    const { response } = await AppService.team.get({})
    setTeam(response ? response.data : [])
  }

  const getStaff = async () => {
    const { response } = await AppService.user.GetTeam({ toaster: false })
    setStaffData(response ? response.data : [])
  }

  const handleOpenModal = () => {
    setOpenEditModal(true)
  }

  const handleCloseModal = () => {
    setOpenEditModal(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    const payload = {
      _id: editData._id,
      name: e.target.name.value,
      description: e.target.description.value,
      staff_team: e.target.staff_team ? JSON.parse(e.target.staff_team.value) : [],
      team: e.target.team ? JSON.parse(e.target.team.value) : [],
      staff_tag: e.target.staff_tag ? JSON.parse(e.target.staff_tag.value) : [],
      cost_price: e.target.cost_price.value,
      resell_price: e.target.resell_price.value,
      category: e.target.category.value,
    }

    const { response } = await AppService.team_services.update({ payload })

    if (response) {
      setProcessing(false)
      handleCloseModal()
      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    height: 'auto',
    overflow: 'auto',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton variant="contained" color="warning" size="small" sx={{ marginLeft: 2 }} onClick={handleOpenModal}>
        Edit
      </MDButton>

      <MDModal open={openEditModal} onClose={handleCloseModal}>
        <MDBox component="form" onSubmit={handleSubmit} sx={style}>
          <MDTypography variant="h5" mb={2}>
            Edit Service
          </MDTypography>

          {/* Name */}
          <MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Name
            </MDTypography>
            <MDInput label="Name" name="name" defaultValue={editData?.name} fullWidth required />
          </MDBox>

          {/* Description */}
          <MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Description
            </MDTypography>
            <TextareaAutosize
              minRows={3}
              name="description"
              defaultValue={editData?.description}
              style={{ width: '100%', padding: '8px', borderRadius: '4px', borderColor: '#ccc' }}
            />
          </MDBox>

          {/* Tags */}
          <MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Tags
            </MDTypography>
            <Multiselect data={tags.map(t => ({ label: t.name, value: t._id }))} edit_data={editData?.staff_tag} isMulti={true} name="staff_tag" />
          </MDBox>

          {/* Staff */}
          <MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Staff
            </MDTypography>
            <Multiselect data={staffData.map(s => ({ label: s.username, value: s._id }))} edit_data={editData?.staff_team} isMulti={true} name="staff_team" />
          </MDBox>

          {/* Team */}
          <MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Team
            </MDTypography>
            <Multiselect data={team.map(t => ({ label: t.name, value: t._id }))} edit_data={editData?.team} isMulti={true} name="team" />
          </MDBox>

          {/* Cost Price */}
          <MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Cost Price
            </MDTypography>
            <MDInput label="Cost Price" name="cost_price" defaultValue={editData?.cost_price} fullWidth />
          </MDBox>

          {/* Resell Price */}
          <MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Resell Price
            </MDTypography>
            <MDInput label="Resell Price" name="resell_price" defaultValue={editData?.resell_price} fullWidth />
          </MDBox>

          {/* Category */}
          <MDBox mb={2}>
            <MDTypography variant="button">Category</MDTypography>
            <MDInput select name="category" fullWidth required SelectProps={{ native: true }} defaultValue={editData?.category}>
              <option value="">Select a category</option>
              {categories.map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.name}
                </option>
              ))}
            </MDInput>
          </MDBox>

          {/* Buttons */}
          <MDBox display="flex" justifyContent="flex-end">
            <MDButton variant="gradient" color="primary" type="button" sx={{ mt: 4, mb: 1 }} onClick={handleCloseModal}>
              Close
            </MDButton>
            <MDButton variant="gradient" color="info" type="submit" sx={{ mt: 4, mb: 1, ml: 1 }} loading={processing} disabled={processing}>
              Update
            </MDButton>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditModal
